// extracted by mini-css-extract-plugin
export var active = "styles-module--active--66602";
export var button = "styles-module--button--57d9a";
export var container = "styles-module--container--c7a50";
export var crossContainer = "styles-module--crossContainer--9e55a";
export var hidden = "styles-module--hidden--c953e";
export var text = "styles-module--text--10a13";
export var whiteCross = "styles-module--whiteCross--fa006";